(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[93569],{

/***/ 36985:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/fullcoveragewarranty/[category]",
      function () {
        return __webpack_require__(47079);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 47079:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "default": function() { return /* binding */ CategoryPage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_layouts_fullCoverageWarrantyWrapper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13219);
/* harmony import */ var _components_fullcoveragewarranty_categoryForm__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70111);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(88737);
/* harmony import */ var _components_fullcoveragewarranty_whatIsHomeWarrantyCategoryPage__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(63868);
/* harmony import */ var _components_fullcoveragewarranty_howIsHomeWarranty__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(27397);
/* harmony import */ var _components_fullcoveragewarranty_whoIsHomeWarranty__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(66709);
/* harmony import */ var _components_fullcoveragewarranty_carWarranty__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(17349);
/* harmony import */ var _components_fullcoveragewarranty_whatIsCarWarrantyCategoryPage__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(71527);
/* harmony import */ var _components_fullcoveragewarranty_carWarrantyCover__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(32122);












var __N_SSP = true;
function CategoryPage({ form  }) {
    const { category  } = (0,_hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_4__/* .useDomainContext */ .w)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_layouts_fullCoverageWarrantyWrapper__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_fullcoveragewarranty_categoryForm__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
                form: form
            }),
            _components_fullcoveragewarranty_categoryForm__WEBPACK_IMPORTED_MODULE_2__/* .AllowedSlugsHome.includes */ .x6.includes(category?.slug) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_fullcoveragewarranty_whatIsHomeWarrantyCategoryPage__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_fullcoveragewarranty_howIsHomeWarranty__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_fullcoveragewarranty_whoIsHomeWarranty__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {})
                ]
            }),
            _components_fullcoveragewarranty_categoryForm__WEBPACK_IMPORTED_MODULE_2__/* .AllowedSlugsAuto.includes */ .pA.includes(category?.slug) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_fullcoveragewarranty_carWarranty__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_fullcoveragewarranty_whatIsCarWarrantyCategoryPage__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_fullcoveragewarranty_carWarrantyCover__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {})
                ]
            })
        ]
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [92592,10621,57079,10761,71698,56965,49774,92888,40179], function() { return __webpack_exec__(36985); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);